import {
  GET_ALL_CONTROLS_SUCCESS,
  CREATE_CONTROL_SUCCESS,
  CANCEL_CONTROL_SUCCESS,
  SET_CONTROLS_SUCCESS,
  GET_DELETED_CONTROLS_SUCCESS,
  SET_DELETED_CONTROLS_SUCCESS
} from './actions';

const initialState = {
  controls: [],
  deletedControls: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_CONTROLS_SUCCESS:
    case CREATE_CONTROL_SUCCESS:
    case SET_CONTROLS_SUCCESS:
      return {
        ...state,
        controls: action.data
      };
    case CANCEL_CONTROL_SUCCESS:
      // TODO: Redux update of cancelled controls?
      return {
        ...state
      };
    case SET_DELETED_CONTROLS_SUCCESS:
    case GET_DELETED_CONTROLS_SUCCESS:
      return {
        ...state,
        deletedControls: action.data
      };
    default:
      return state;
  }
};

export default reducer;
